import React from 'react';
import {uniqueId} from 'lodash';
import {Link} from 'react-router-dom';
import styles from './body.module.scss';

interface CellValue {
  value: React.ReactNode;
  to?: string;
}

type Row = CellValue[];

interface EmptyState {
  numberOfColumns: number;
  text: React.ReactNode;
}

interface Props {
  rows: Row[];
  emptyState?: EmptyState;
}

const Body = ({rows, emptyState}: Props): React.ReactElement => (
  <tbody data-testid="simple-table-body">
    {rows.map((row) => (
      <tr key={uniqueId('table-row')} className={styles.tr} data-testid="simple-table-row">
        {row.map(({value, to}) => {
          let element: React.ReactNode = value;

          if (to) {
            element = (
              <Link to={to} className={styles.link} data-testid="table-row-link">
                {value}
              </Link>
            );
          }

          return (
            <td key={uniqueId('table-row-data')} className={styles.td} data-testid="table-row-data">
              {element}
            </td>
          );
        })}
      </tr>
    ))}
    {rows.length < 1 && !!emptyState && (
      <tr>
        <td
          colSpan={emptyState.numberOfColumns}
          className={styles.empty}
          data-testid="empty-table-row-data"
        >
          {emptyState.text}
        </td>
      </tr>
    )}
  </tbody>
);

export default Body;
